import con from '../../../connection';
var path = '/islogin';
var islogin = function (url) { return function () { return ({
    get: function (option) { return con.get(url + path, {}, option === null || option === void 0 ? void 0 : option.noError, option === null || option === void 0 ? void 0 : option.noNetworkError); },
}); }; };
export default islogin;
